// @ts-nocheck
import "./style.scss";

import UnsupportedCurrencyFooter from "components/swap/UnsupportedCurrencyFooter";
import useActiveWeb3React from "hooks/useActiveWeb3React";
import { useCallback, useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { RouteComponentProps } from "react-router-dom";
import { useDerivedMintInfo } from "state/mint/hooks";
import { TransactionResponse } from "@ethersproject/providers";
import { formatUnits } from "@ethersproject/units";
import { Currency, Percent } from "@uniswap/sdk-core";
import { ButtonPrimary } from "../../components/Button";
import { AutoColumn } from "../../components/Column";
import PositionListItemV3 from 'components/PositionListItemV3'
import CurrencyInputPanel from "../../components/CurrencyInputPanel";
import CurrencyInputPanelLimited from "../../components/CurrencyInputPanel/limited";
import { AddRemoveTabs } from "../../components/NavigationTabs";
import { AutoRow, RowBetween } from "../../components/Row";
import TransactionConfirmationModal, { ConfirmationModalContent } from "../../components/TransactionConfirmationModal";
import { LP_MIGRATOR_ADDRESSES, NONFUNGIBLE_POSITION_MANAGER_ADDRESSES } from "../../constants/addresses";
import { WRAPPED_NATIVE_CURRENCY } from "../../constants/tokens";
import { useCurrency } from "../../hooks/Tokens";
import { useV3Positions } from 'hooks/useV3Positions'
import {
  ApprovalState,
  useApproveCallback
} from "../../hooks/useLiquiditySpender";
import { useMigratorContract } from "../../hooks/useContract";
import { useIsSwapUnsupported } from "../../hooks/useIsSwapUnsupported";
import { useUSDCValue } from "../../hooks/useUSDCPrice";
import { useWalletModalToggle } from "../../state/application/hooks";
import { Field } from "../../state/mint/v3/actions";
import { TransactionType } from "../../state/transactions/actions";
import { useTransactionAdder } from "../../state/transactions/hooks";
import { useTokenBalance } from "../../state/wallet/hooks";
import { ThemedText } from "../../theme";
import { currencyId } from "../../utils/currencyId";
import {
  DynamicSection,
  PageWrapper,
  ResponsiveTwoColumns,
  ScrollablePage,
  Wrapper
} from "./styled";

const DEFAULT_ADD_IN_RANGE_SLIPPAGE_TOLERANCE = new Percent(50, 10_000)

export default function AddTokenV3({
  match: {
    params: { currencyIdA, currencyIdB },
  },
  history,
}: RouteComponentProps<{ currencyIdA?: string; currencyIdB?: string; }>) {
  const { account, chainId } = useActiveWeb3React()
  // @ts-ignore
  const toggleWalletModal = useWalletModalToggle() // toggle wallet when disconnected

  const { positions, loading: positionsLoading } = useV3Positions(account)
  const [filteredPostions, setFilteredPositions] = useState([])

  const baseCurrency = useCurrency(currencyIdA)
  const currencyB = useCurrency(currencyIdB)
  // prevent an error if they input ETH/WETH
  // const quoteCurrency =
  //   baseCurrency && currencyB && baseCurrency.wrapped.equals(currencyB.wrapped) ? undefined : currencyB

  const {
    currencies,
    parsedAmounts,
    pair,
  } = useDerivedMintInfo(baseCurrency ?? undefined, currencyB ?? undefined, 'SELECT_POOL_MIGRATE')
  // modal and loading
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [attemptingTxn, setAttemptingTxn] = useState<boolean>(false) // clicked confirm
  const [waiting, setWaiting] = useState<boolean>(false)
  const [clickable, setClickable] = useState<boolean>(true)
  // const [invalid, setInvalid] = useState<boolean>(false)
  // const [insufficient, setInsufficient] = useState<boolean>(false)
  const pool = window.localStorage.getItem('SELECT_POOL_MIGRATE') || 'UniswapV2';
  const [tokenId, setTokenId] = useState('')
  // capital efficiency warning
  const migrateContract = useMigratorContract(pool.toLowerCase());

  const userPoolBalance = useTokenBalance(account ?? undefined, pair?.liquidityToken)
  let maxBalance = formatUnits(userPoolBalance !== undefined ? userPoolBalance?.quotient.toString() : "0", pair?.liquidityToken.decimals);
  const temp = maxBalance.split(".");
  if(temp.length >= 2) {
    if(temp[1].length > 6) {
      maxBalance = temp[0] + "." + temp[1].slice(0, 6);
    }
  }

  const [approval, approveCallback] = useApproveCallback(NONFUNGIBLE_POSITION_MANAGER_ADDRESSES[chainId], tokenId ? tokenId : 0, LP_MIGRATOR_ADDRESSES[chainId] ? LP_MIGRATOR_ADDRESSES[chainId][pool.toLowerCase()] : "");
  console.log(approval);
  const [txHash, setTxHash] = useState<string>('')

  const usdcValues = {
    [Field.CURRENCY_A]: useUSDCValue(parsedAmounts[Field.CURRENCY_A]),
    [Field.CURRENCY_B]: useUSDCValue(parsedAmounts[Field.CURRENCY_B]),
  }

  useEffect(() => {
    if(currencyIdA && currencyIdB && positionsLoading ===false) {
      const [token0, token1] = currencyIdA.toLowerCase() < currencyIdB.toLowerCase() ? [currencyIdA.toLowerCase(), currencyIdB.toLowerCase()] : [currencyIdB.toLowerCase(), currencyIdA.toLowerCase()];
      const filtered = positions?.filter(position => position.token0.toLowerCase() === token0 && position.token1.toLowerCase() === token1);
      setFilteredPositions(filtered);
    }
  }, [currencyIdA, currencyIdB, chainId, positionsLoading, positions])

  const addTransaction = useTransactionAdder()
  async function onImport() {
    if(!clickable) return
    setClickable(false)
    if (!chainId || !account) return

    if (migrateContract && account) {
      try {
        await migrateContract.importLPTokens(tokenId)
          .then(async (response: TransactionResponse) => {
            setTxHash(response.hash)
            addTransaction(response, {
              type: TransactionType.MIGRATE_LIQUIDITY_V3,
              baseCurrencyId: currencyId(baseCurrency),
              quoteCurrencyId: currencyId(currencyB),
              isFork: true
            })
            setShowConfirm(true)
            await response.wait()
            setAttemptingTxn(false)
            setWaiting(false);
          })

        ReactGA.event({
          category: 'Liquidity',
          action: 'Import',
          label: [pair?.token0?.symbol, pair?.token1?.symbol].join('/'),
        })
      } catch (error) {
        setWaiting(false);
        console.error('Failed to send transaction', error)
        setAttemptingTxn(false)
        // we only care if the error is something _other_ than the user rejected the tx
        if (error?.code !== 4001) {
          console.error(error)
        }
      } finally {
        setClickable(true)
      }
    }
  }

  const showConnectAWallet = Boolean(!account)
  const handleCurrencySelect = useCallback(
    (currencyNew: Currency, currencyIdOther?: string): (string | undefined)[] => {
      const currencyIdNew = currencyId(currencyNew)

      if (currencyIdNew === currencyIdOther) {
        // not ideal, but for now clobber the other if the currency ids are equal
        return [currencyIdNew, undefined]
      } else {
        // prevent weth + eth
        const isETHOrWETHNew =
          currencyIdNew === 'ETH' ||
          (chainId !== undefined && currencyIdNew === WRAPPED_NATIVE_CURRENCY[chainId]?.address)
        const isETHOrWETHOther =
          currencyIdOther !== undefined &&
          (currencyIdOther === 'ETH' ||
            (chainId !== undefined && currencyIdOther === WRAPPED_NATIVE_CURRENCY[chainId]?.address))

        if (isETHOrWETHNew && isETHOrWETHOther) {
          return [currencyIdNew, undefined]
        } else {
          return [currencyIdNew, currencyIdOther]
        }
      }
    },
    [chainId]
  )

  const handleCurrencyASelect = useCallback(
    (currencyANew: Currency) => {
      const [idA, idB] = handleCurrencySelect(currencyANew, currencyIdB)
      if (idB === undefined) {
        history.push(`/migrate/import/${idA}`)
      } else {
        history.push(`/migrate/import/${idA}/${idB}`)
      }
    },
    [handleCurrencySelect, currencyIdB, history]
  )

  const handleCurrencyBSelect = useCallback(
    (currencyBNew: Currency) => {
      const [idB, idA] = handleCurrencySelect(currencyBNew, currencyIdA)
      if(currencyId(currencyBNew) === currencyIdA) {
        history.push(`/migrate/import/${idB}`)
      } else if (idA === undefined) {
        history.push(`/migrate/import/0x0/${idB}`)
      } else {
        history.push(`/migrate/import/${idA}/${idB}`)
      }
    },
    [handleCurrencySelect, currencyIdA, history]
  )

  const handleDismissConfirmation = useCallback(() => {
    setShowConfirm(false)
    // if there was a tx hash, we want to clear the input
    if (txHash) {
      // dont jump to pool page if creating
      history.push('/migrate/v2')
    }
    setTxHash('')
  }, [history, txHash])

  const addIsUnsupported = useIsSwapUnsupported(currencies?.CURRENCY_A, currencies?.CURRENCY_B)

  // const pendingText = (<>Migrating {inputBalance} {currencies[Field.CURRENCY_A]?.symbol} / {currencies[Field.CURRENCY_B]?.symbol}</>);
  const pendingText = (<>Migrating {currencies[Field.CURRENCY_A]?.symbol} / {currencies[Field.CURRENCY_B]?.symbol}</>);
  const Buttons = () =>
    addIsUnsupported ? (
      <ButtonPrimary disabled={true} $borderRadius="12px" padding={'12px'}>
        <ThemedText.Main mb="4px">
          Unsupported Asset
        </ThemedText.Main>
      </ButtonPrimary>
    ) : (
      <AutoColumn gap={'md'}>
      </AutoColumn>
    )

  return (
    <>
      <ScrollablePage>

        <TransactionConfirmationModal
          isOpen={showConfirm}
          onDismiss={handleDismissConfirmation}
          attemptingTxn={attemptingTxn}
          hash={txHash}
          content={() => (
            <ConfirmationModalContent
              title={""}
              onDismiss={handleDismissConfirmation}
              bottomContent={() => (
                <button className='view-etherscan'>
                  <p>
                    View on Block Explorer
                  </p>
                </button>
              )}
            />
          )}
          pendingText={pendingText}
        />

        <div className='add-token-page'>
          <div className='remove-tab-warrap'>
            <PageWrapper wide={true} className="remove-tab">
              <AddRemoveTabs
                creating={false}
                adding={false}
                migrate={true}
                defaultSlippage={DEFAULT_ADD_IN_RANGE_SLIPPAGE_TOLERANCE}
                showBackLink={true}
              />
              <Wrapper className='remove-tab-content' >
                <ResponsiveTwoColumns wide={true} style={{ display: "block" }} className="remove-tab-content-inner">
                  <div>
                    <DynamicSection
                      className="deposit-amount"
                    >
                      <AutoRow gap="md">
                        <RowBetween style={{marginBottom:'32px'}}>
                          <ThemedText.Label style={{ fontSize: "16px", color: "white" }}>
                            Select a Capital
                          </ThemedText.Label>
                          <div className='toToken' style={{ display: "flex", justifyContent: "space-between" }}>
                            <CurrencyInputPanelLimited
                              fiatValue={usdcValues[Field.CURRENCY_A]}
                              currency={currencies[Field.CURRENCY_A] ?? null}
                              onCurrencySelect={handleCurrencyASelect}
                              id="add-liquidity-input-tokenb"
                              showCommonBases
                              disabled={waiting || approval === ApprovalState.PENDING}
                              hideInput={true}
                            />
                          </div>
                        </RowBetween>
                        <RowBetween style={{marginBottom: '32px'}}>
                          <ThemedText.Label style={{ fontSize: "16px", color: "white" }}>
                            Select a Token
                          </ThemedText.Label>
                          <div className='toToken' style={{ display: "flex", justifyContent: "space-between", width: 160 }}>
                            <CurrencyInputPanel
                              fiatValue={usdcValues[Field.CURRENCY_B]}
                              currency={currencies[Field.CURRENCY_B] ?? null}
                              onCurrencySelect={handleCurrencyBSelect}
                              id="add-liquidity-input-tokenb"
                              showCommonBases
                              disabled={waiting || approval === ApprovalState.PENDING}
                              hideInput={true}
                            />
                          </div>
                        </RowBetween>
                        {filteredPostions !== undefined && filteredPostions?.map((p, index) => {
                          return <PositionListItemV3 setTokenId={setTokenId} activeTokenId={tokenId} index={index} key={p.tokenId.toString()} positionDetails={p} />
                        })}
                      </AutoRow>
                    </DynamicSection>
                  </div>
                  <Buttons />
                </ResponsiveTwoColumns>
              </Wrapper>
              {showConnectAWallet ? (
                <div className='add-liquidity-footer'>
                  <button className='add-liquidity'  onClick={toggleWalletModal}><p>Connect Wallet</p></button>
                </div>
              ):(
                  <div className='add-liquidity-footer'>
                    { approval === ApprovalState.NOT_APPROVED ? <button className='add-liquidity' style={{ border: "0px" }} onClick={approveCallback} ><p>Approve</p></button>
                      : (
                        approval === ApprovalState.PENDING
                          ?
                          <button className='add-liquidity' style={{ border: "0px", opacity:'0.45' }}><p style={{ color: "white" }}>Approving...</p></button>
                          :
                          <div className='add-liquidity-warrap'>
                            <button className='add-liquidity' disabled={!(clickable && tokenId !== "")} style={clickable && tokenId !== "" ?{ border: "0px" }:{border:'0px',cursor: 'not-allowed',opacity:'0.45'}} onClick={onImport}>
                              <p>{waiting?'Transaction in progress-Please wait':'Import'}</p>
                            </button>
                          </div>
                      )
                    }
                  </div>
                )
              }
            </PageWrapper>
          </div>
        </div>
        {addIsUnsupported && (
          <UnsupportedCurrencyFooter
            show={addIsUnsupported}
            currencies={[currencies.CURRENCY_A, currencies.CURRENCY_B]}
          />
        )}
      </ScrollablePage>
    </>
  )
}
